import {
  Component,
  ViewChild,
  ElementRef,
  OnInit,
  // TemplateRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "../../common.service";
import { DomSanitizer } from "@angular/platform-browser";
import {
  NgbModal,
  // NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { AppFolioSignUpCompany } from "src/app/_models/appfolioSignUpCompany";
import { AppFolioService } from "src/app/_services/appfolioService";
import { LogEntry } from "src/app/_models/logEntry";
import { TokenLogService } from "src/app/_services/tokenLogService";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-contract",
  templateUrl: "./appfolio-contract.component.html",
  styleUrls: ["./appfolio-contract.component.css"],
})
export class AppfolioContractComponent implements OnInit {
  @ViewChild("iframe", { static: true }) iframe: ElementRef;
  @ViewChild("content", { static: true }) private contentRef: NgbModalRef;
  public defaultCheck1: boolean = false;
  public defaultCheck1Error: any;
  public error: string;
  public token: any =
    "3AAABLblqZhB7chSSVUtgXIYKpiL7DaiL3jsD8FZbR0AhC4S4eoCSzLs7_VUnKEAEdztDxX2jcsfj1X3nKzPyAH-kicAS5TmE";
  public url: string = "https://api.in1.echosign.com/api/rest/v6/agreements";
  public iframeURL: any;
  public registrationDetails: any;
  public adobeSignIFrame: ElementRef;
  public modalOpened = false;

  company: string;
  NumProperty: number;
  NumUnits: number;
  address: string;
  city: string;
  state: string;
  zipCode: number;
  name: string;
  phone: number;
  extension: number;
  email: string;
  ipAddress: string;
  registrationFormData: object;
  firstName: string;
  lastName: string;
  sessionId: string;
  vHostName: string;
  appfolioSignUpCompany: AppFolioSignUpCompany;
  eframeIsLoading: boolean;

  constructor(
    private router: Router,
    public authService: CommonService,
    public sanitizer: DomSanitizer,
    private readonly tokenLogService: TokenLogService,
    // private readonly xrmService: XrmService,
    private modalService: NgbModal,
    private appfolioService: AppFolioService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.eframeIsLoading = true;
    this.spinner.show();
    this.registrationFormData = JSON.parse(
      localStorage.getItem("appfolioFirstRegistrationDetails")
    );
    this.appfolioSignUpCompany = JSON.parse(
      localStorage.getItem("appfolioSigUpCompany")
    );
    // this.xrmEntry = JSON.parse(localStorage.getItem("xrmEntry"));
    // logging third page
    this.company = this.registrationFormData["Name"];
    this.NumProperty = this.registrationFormData["NumProperty"];
    this.NumUnits = this.registrationFormData["NumUnits"];
    this.address = this.registrationFormData["Address"];
    this.city = this.registrationFormData["City"];
    this.state = this.registrationFormData["State"];
    this.zipCode = this.registrationFormData["ZipCode"];
    this.firstName = this.registrationFormData["FirstName"];
    this.lastName = this.registrationFormData["LastName"];
    this.name = `${this.firstName} ${this.lastName}`;
    this.phone = this.registrationFormData["Phone"];
    this.extension = this.registrationFormData["Extension"];
    this.email = this.registrationFormData["Email"];
    const ipAddress = localStorage.getItem("clientIPAddress");
    this.sessionId = localStorage.getItem("sessionId");
    this.vHostName = this.registrationFormData["VHostName"];

    const logEntry: LogEntry = {
      pageNumber: 2,
      companyName: this.company,
      vendorClientUniqueId: null,
      message: "Contract page reached for AppFolio",
      exception: null,
      clientId: null,
      clientSecret: null,
      email: this.email,
      phone: this.phone.toString(),
      contactName: this.firstName + " " + this.lastName,
      sessionId: this.sessionId,
      password: null,
      companyLegalName: null,
      numberOfProperties: this.NumProperty,
      numberOfUnits: this.NumUnits,
      street1: this.address,
      city: this.city,
      state: this.state,
      zipCode: this.zipCode.toString(),
      country: "US",
      settlementAuth: "80",
      clientVendorId: 2,
    };

    this.tokenLogService
      .logEntry(logEntry)
      .toPromise()
      .then(
        () => {
          console.log("Token entry set correctly");
        },
        (error) => {
          console.log(
            "An error has occurred while creating log entry: ",
            error
          );
        }
      );

    let fullUrl =
      "https://residentinterface.na1.echosign.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhCpO45OBpkTNAXVWNP0Fjw6sF6FitECMqh4-wSxgvSf3UzzRedccMj1UjWgW3HTaPg*";
      "https://residentinterface.na1.echosign.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhCpO45OBpkTNAXVWNP0Fjw6sF6FitECMqh4-wSxgvSf3UzzRedccMj1UjWgW3HTaPg*"
    fullUrl += `#Company=${this.company.replace(
      " ",
      "%20"
    )}&Address=${this.address.replace(
      " ",
      "%20"
    )}&CityStateZip=${this.city.replace(" ", "%20")}%20${this.state.replace(
      " ",
      "%20"
    )}%20${this.zipCode}&Name=${this.name.replace(" ", "%20")}`;
    fullUrl += `&Phone=${this.phone}&Extension=${this.extension}&Email=${
      this.email
    }&IPAddress=${`IP Address: ${ipAddress}`}`;
    console.log(fullUrl);
    this.iframeURL = this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
  }

  createCompany() {
    // adding log entry when client signed the contract
    const logEntry: LogEntry = {
      pageNumber: 2,
      companyName: this.company,
      vendorClientUniqueId: null,
      message:
        "Client signed the contract, will create record for AppFolio Company next",
      exception: null,
      clientId: null,
      clientSecret: null,
      email: this.email,
      phone: this.phone.toString(),
      contactName: this.firstName + " " + this.lastName,
      sessionId: this.sessionId,
      password: null,
      companyLegalName: null,
      numberOfProperties: this.NumProperty,
      numberOfUnits: this.NumUnits,
      street1: this.address,
      city: this.city,
      state: this.state,
      zipCode: this.zipCode.toString(),
      country: "US",
      settlementAuth: "80",
      clientVendorId: 2,
    };

    this.tokenLogService
      .logEntry(logEntry)
      .toPromise()
      .then(
        () => {
          console.log("Token entry set correctly");
        },
        (error) => {
          console.log(
            "An error has occurred while creating log entry: ",
            error
          );
        }
      );

    this.modalService.open(this.contentRef);
    this.createServiceRecord();
  }

  createServiceRecord() {
    this.appfolioService
      .saveAppFolioCompany(this.appfolioSignUpCompany)
      .toPromise()
      .then((_: any) => {
        this.modalService.dismissAll();
        this.router.navigate(["appfolio/welcome"]);
      })
      .catch((error) => {
        console.log(
          "An error occurred while creating management company:",
          error
        );
        const logEntry: LogEntry = {
          pageNumber: 2,
          companyName: this.company,
          vendorClientUniqueId: null,
          message:
            "An error has occurred while creating management company fro AppFolio",
          exception: null,
          clientId: null,
          clientSecret: null,
          email: this.email,
          phone: this.phone.toString(),
          contactName: this.firstName + " " + this.lastName,
          sessionId: this.sessionId,
          password: null,
          companyLegalName: null,
          numberOfProperties: this.NumProperty,
          numberOfUnits: this.NumUnits,
          street1: this.address,
          city: this.city,
          state: this.state,
          zipCode: this.zipCode.toString(),
          country: "US",
          settlementAuth: "80",
          clientVendorId: 2,
        };

        this.tokenLogService
          .logEntry(logEntry)
          .toPromise()
          .then(
            () => {
              console.log("Token entry set correctly");
            },
            (error) => {
              console.log(
                "An error has occurred while creating log entry: ",
                error
              );
            }
          );
      });
  }

  closeSpinner() {
    this.eframeIsLoading = false;
    setTimeout(() => {
      this.spinner.hide();
    }, 2500);
  }
}
